import uniq from "lodash/uniq";
import { useFormContext } from "react-hook-form";
const useGroupBy = (props) => {
    const {
        maxGroupByAllowed,
        groupByOptions
    } = props;

    const { watch, setValue } = useFormContext();

    const selectedGroupBy = uniq(watch("groupBy"));

    const handleGroupBy = (value) => {
        const tempGroupBy = selectedGroupBy;
        const index = tempGroupBy?.indexOf(value);
        if (index > -1) {
            tempGroupBy.splice(index, 1);
        } else {
            tempGroupBy.push(value);
        }
        setValue("groupBy", [...tempGroupBy], { shouldDirty: true });
    };

    const handleSelectActions = (action) => {
        if (action === "clear") {
            setValue(
                "groupBy",
                groupByOptions.filter((item) => item.disabled)?.map((item) => item.value),
                { shouldDirty: true }
            );
        } else {
            if (maxGroupByAllowed) {
                setValue(
                    "groupBy",
                    groupByOptions
                        .map((item) => item.value)
                        .slice(0, maxGroupByAllowed)
                    ,
                    { shouldDirty: true }
                );
            } else {
                setValue(
                    "groupBy",
                    groupByOptions.map((item) => item.value)
                    ,
                    { shouldDirty: true }
                );
            }
        }
    };

    return {
        handleSelectActions,
        handleGroupBy,
        selectedGroupBy
    };
};

export default useGroupBy;
